import { onBeforeUnmount, onMounted } from '@nuxtjs/composition-api'
import { throttle } from 'throttle-debounce'

export const useTrackScrollDistance = (run: () => void, threshold = 10) => {
  let scrollDistance = 0
  let scrollPosition = null
  let resetCallbackId = null

  const resetScrollDistance = () => {
    scrollDistance = 0
  }

  const onScroll = throttle(50, () => {
    scrollDistance += Math.abs(scrollPosition - window.scrollY)
    scrollPosition = window.scrollY
    clearTimeout(resetCallbackId)
    resetCallbackId = setTimeout(resetScrollDistance, 100)
    if (scrollDistance > threshold) run()
  })

  onMounted(() => {
    scrollPosition = window.scrollY
    window.addEventListener('scroll', onScroll)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)
  })
}
